import { formatCurrency, formatDate } from '@if/core/utils'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IFinanceBaseWorksheet } from '../../../../data/types/IFinanceBaseWorksheetSchema'

interface Props {
  worksheet: IFinanceBaseWorksheet
}

const BorrowerSection = ({ worksheet }: Props) => {
  const { t } = useTranslation()

  return (
    <Stack direction="column">
      <Typography variant="h6" component="div" gutterBottom>
        {t('worksheetCommon.borrowersPayments')}
      </Typography>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheet.term')} :</Typography>
        <Typography variant="subtitle1">
          {worksheet?.term} {t('worksheet.month')}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheet.paymentFrequency')} :</Typography>
        <Typography>
          {worksheet.paymentFrequency
            ? t(`EPaymentFrequency.${worksheet.paymentFrequency}`, { ns: 'enum' })
            : t('EPaymentFrequency.monthly', { ns: 'enum' })}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheetCommon.payment')} :</Typography>
        <Typography variant="subtitle1">{formatCurrency(worksheet?.paymentAmountForFrequency)}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheetCommon.activationDate')} :</Typography>
        <Typography variant="subtitle1">{worksheet?.deliveryOn}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheetCommon.firstPaymentDate')} :</Typography>
        <Typography variant="subtitle1">{formatDate(worksheet?.firstPaymentOn)}</Typography>
      </Stack>
    </Stack>
  )
}

export default BorrowerSection